const parseDob = (dob) => {
  if (!dob || typeof dob !== "string") return null;

  const value = dob.trim();
  let day;
  let month;
  let year;

  const dayFirstMatch = value.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
  const isoMatch = value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);

  if (dayFirstMatch) {
    [, day, month, year] = dayFirstMatch;
  } else if (isoMatch) {
    [, year, month, day] = isoMatch;
  } else {
    return null;
  }

  const parsedDate = new Date(Number(year), Number(month) - 1, Number(day));
  if (
    parsedDate.getFullYear() !== Number(year) ||
    parsedDate.getMonth() !== Number(month) - 1 ||
    parsedDate.getDate() !== Number(day)
  ) {
    return null;
  }

  return parsedDate;
};

export const isUnder18 = (dob) => {
  const birthDate = parseDob(dob);
  if (!birthDate) return false;

  const eighteenthBirthdayCutoff = new Date();
  eighteenthBirthdayCutoff.setHours(0, 0, 0, 0);
  eighteenthBirthdayCutoff.setFullYear(
    eighteenthBirthdayCutoff.getFullYear() - 18
  );

  return birthDate > eighteenthBirthdayCutoff;
};

const CONSENT_SESSION_KEY = "jobseeker_consent_completed";

export const requiresConsent = (profile) => {
  if (!profile || Array.isArray(profile)) return false;

  const dob = typeof profile.dob === "string" ? profile.dob.trim() : "";
  return !dob || !parseDob(dob) || isUnder18(dob);
};

export const hasCompletedConsentThisSession = () =>
  sessionStorage.getItem(CONSENT_SESSION_KEY) === "true";

export const markConsentCompletedThisSession = () => {
  sessionStorage.setItem(CONSENT_SESSION_KEY, "true");
};

export const clearConsentSession = () => {
  sessionStorage.removeItem(CONSENT_SESSION_KEY);
};

export const shouldRedirectToConsent = (profile) =>
  requiresConsent(profile) && !hasCompletedConsentThisSession();
